var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://recrutement.popvalet.com/"}},[_c('div',{class:[`cta_devenir_valet-1`, _vm.className || ``]},[_c('div',{staticClass:"devenir-valet blogtextbold"},[_vm._v("DEVENIR VALET")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }